const resortButton = $('.resortButton');
const resortsSubMenu = $('.resorts-submenu');
const additionalFilters = $('.filters-additional');
const additionalFiltersButton = $('.filterToggle');
const countryButtonsWrap = $('.resorts-submenu-col-1');
const chaletLists = $('.resorts-submenu-col-2 fieldset');
const chaletListButtonSelectAll = $('.resorts-submenu-col-2 fieldset button.select-all');
const chalet = $('.resorts-submenu-col-2 input');
const inputControls = $('.inputControl');
const chaletButton = $('.chaletButton');
const chaletSubMenu = $('.chalets-submenu');

/** Sets the chalet list based on the data-menu attribute of the button clicked */
function updateChaletList(menuNumber) {

    chaletLists.each(function () {
        if ($(this).data('menu') === menuNumber) {
            $(this).css({
                display: 'flex'
            })
        } else {
            $(this).css({
                display: 'none'
            })
        }
    });
}

/** Adds/removes __checked class to the label wrapper of radiobutton/checkbox clicked */
function toggleParentLabel(el, active) {
    let parentLabel = el.closest('label');

    if (active) {
        parentLabel.addClass('__checked');
    } else {
        parentLabel.removeClass('__checked');
    }
};

/** Closes all menus */
function resetMenu() {
    resortsSubMenu.removeClass('__active');
    chaletSubMenu.removeClass('__active');
    resortButton.attr('aria-expanded', false);
    chaletButton.attr('aria-expanded', false);
}

function setMenu(el) {
    if (el.hasClass('resortButton')) {
        chaletSubMenu.removeClass('__active');
        resortsSubMenu.toggleClass('__active');
    } else {
        resortsSubMenu.removeClass('__active');
        chaletSubMenu.toggleClass('__active');
    }

    el.attr('aria-expanded', el.attr('aria-expanded') === 'true' ? 'false' : 'true');
}

// ADDITIONAL FILTERS DROPDOWN
additionalFiltersButton.click(function (e) {
    let thisElement = $(this);

    e.preventDefault();
    additionalFilters.toggleClass('__active');
    thisElement.attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
});


// RESORTS + CHALET FILTERS DROPDOWN
$(document).click(function (e) {
    const targets = $(e.target).parents()
    if (targets.hasClass('__resorts') || targets.hasClass('__chalets')) {
        // check if e.target is resorts button
        if ($(e.target).hasClass('resortButton')) {
            e.preventDefault();
            setMenu($(e.target));
        } else if ($(e.target).hasClass('chaletButton')) {
            e.preventDefault();
            setMenu($(e.target));
        }
    } else {
        resetMenu();
    }
})

const resortButtons = $('.resorts-submenu-col-1 > button');
resortButtons.each(function () {
    const thisElement = $(this);
    const dataMenu = thisElement.data('menu');

    thisElement.click(function (e) {
        e.preventDefault();
        updateChaletList(dataMenu);
    })
});

chalet.change(function () {
    $this = $(this);
    $this.closest('label').toggleClass('__checked', $this.is(':checked'));
});

chaletLists.change(function () {
    $this = $(this);

    const menu_id = $this.closest('fieldset').data('menu');
    const button_wrap = countryButtonsWrap.find(`[data-menu=${menu_id}]`).first();
    const count = $this.find('input:checked').length;

    button_wrap.toggleClass('__active', 0 < count);
});

chaletListButtonSelectAll.click(function(e) {
    e.preventDefault();
    const thisBtn = $(this);

    if (thisBtn.hasClass('__active')) {
        thisBtn.removeClass('__active');
        thisBtn.siblings('label').children('input').prop('checked', false).trigger('change');
    } else {
        thisBtn.addClass('__active');
        thisBtn.siblings('label').children('input').prop('checked', true).trigger('change');
    }
});

chaletSubMenu.change(function () {
    let subMenuItems = $('.chalets-submenu-col-1 input');

    subMenuItems.each(function () {
        if ($(this).is(':checked')) {
            toggleParentLabel($(this), true)
        } else {
            toggleParentLabel($(this), false);
        }
    })
});


// 'GUESTS' NUMBER INPUT CONTROLS
inputControls.each(function () {
    const siblingInput = $(this).closest('.input_wrap').find('input[type=number]');

    $(this).click(function (e) {
        e.preventDefault();

        if ($(this).hasClass('plus')) {
            siblingInput.val(function (_, prevVal) {
                return parseInt(prevVal) + 1;
            });
        } else {
            if (siblingInput.val() > 1) {
                siblingInput.val(function (_, prevVal) {
                    return parseInt(prevVal) - 1;
                });
            }
        }
    })
});

// OPEN FIRST CHALET LIST
$('.resorts-submenu-col-2 fieldset[data-menu=1]').css({
    'display': 'flex'
});